import * as React from 'react';
import { DetailedIconType } from '../types';
/**
 * @deprecated Please use @fiverr-private/visuals package.
 */
const FullMoonStartsDetailedIcon = ({ size = 48 }: DetailedIconType) => (
    <svg xmlns="http://www.w3.org/2000/svg"
        width={size}
        height={size}
        viewBox="0 0 41 38"
        fill="none">
        <circle cx={15.5} cy={22.5} r={15.5} fill="#ECDDFB"/>
        <path d="m33.006 0 1.82 3.437 3.413 1.833-3.413 1.833-1.82 3.438-1.82-3.438-3.414-1.833 3.413-1.833L33.005 0ZM20.583 4.344l3.68 6.95L31.165 15l-6.902 3.706-3.68 6.95-3.681-6.95L10 15l6.902-3.707 3.68-6.95Zm16.104 16.68-2.301-4.344-2.3 4.343-4.314 2.317 4.313 2.316L34.386 30l2.3-4.344L41 23.34l-4.313-2.317Z"
            fill="#A866EC"/>
    </svg>
);
FullMoonStartsDetailedIcon.displayName = 'FullMoonStartsDetailedIcon';
export default FullMoonStartsDetailedIcon;
